/** @jsx jsx */
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React, { Suspense } from 'react';

import DCSpinner from '../DCSpinner';
import ErrorBoundary from '../ErrorBoundary';

import type { MonacoConsoleProps } from './MonacoConsole';

const consoleImporter = () =>
  import(/* webpackChunkName: "console-monaco" */ './MonacoConsole');

const MonacoConsole = React.lazy(consoleImporter);

type Props = MonacoConsoleProps & {
  id: number | string;
};
const ConsoleLoader: React.FC<Props> = (props) => {
  return (
    <div
      css={{
        width: '100%',
        height: '100%',
        ...(props.uiTheme === 'DARK' && {
          backgroundColor: tokens.colors.navy,
        }),
      }}
    >
      <ErrorBoundary>
        <Suspense fallback={<DCSpinner uiTheme={props.uiTheme} />}>
          <MonacoConsole {...props} key={props.id} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default ConsoleLoader;
